export enum OutboundLoadStatus {
    Planned = 1,
    Loaded,
    Shipped,
    Canceled
}
